"use strict";
/**
* bond_const.ts
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Tool     : bondc, Version=3.0.1, Build=bond-git.debug.not
//     Template : Microsoft.Bond.Rules.dll#TypeScript.tt
//     File     : bond_const.ts
//
//     Changes to this file may cause incorrect behavior and will be lost when
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
var BondDataType;
(function (BondDataType) {
    BondDataType[BondDataType["BT_STOP"] = 0] = "BT_STOP";
    BondDataType[BondDataType["BT_STOP_BASE"] = 1] = "BT_STOP_BASE";
    BondDataType[BondDataType["BT_UINT8"] = 3] = "BT_UINT8";
    BondDataType[BondDataType["BT_UINT32"] = 5] = "BT_UINT32";
    BondDataType[BondDataType["BT_UINT64"] = 6] = "BT_UINT64";
    BondDataType[BondDataType["BT_STRING"] = 9] = "BT_STRING";
    BondDataType[BondDataType["BT_STRUCT"] = 10] = "BT_STRUCT";
    BondDataType[BondDataType["BT_LIST"] = 11] = "BT_LIST";
    BondDataType[BondDataType["BT_MAP"] = 13] = "BT_MAP";
    BondDataType[BondDataType["BT_INT32"] = 16] = "BT_INT32";
    BondDataType[BondDataType["BT_INT64"] = 17] = "BT_INT64";
    BondDataType[BondDataType["BT_UNAVAILABLE"] = 127] = "BT_UNAVAILABLE";
})(BondDataType = exports.BondDataType || (exports.BondDataType = {}));
